import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './GoToCheckoutButton.module.scss';

interface GoToCheckoutButtonProps {
  onCheckout: () => void;
}

const GoToCheckoutButton: React.FC<GoToCheckoutButtonProps> = ({ onCheckout }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.checkOutButton}>
      <OpButton color="action" variant="primary" size="large">
        {t('txt_go_to_checkout')}
      </OpButton>
    </div>
  );
};

export default GoToCheckoutButton;
